export default __webpack_public_path__ + "img/apple_hover.531a6c585c884e26fce90081bae055ab.svg";